import { ArchiveConfig, archiveExecutionHistoryPath, urlCombine } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';
import { coreAPI, handleResponse, standardGet } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class ArchiveConfigHttpService extends CRUDHelperBase<ArchiveConfig> {
	constructor() {
		super(ArchiveConfig.name);
	}

	async runArchive(options?: HttpResponseOptions) {
		const url = urlCombine(coreAPI, ArchiveConfig.name, archiveExecutionHistoryPath);
		const response = await standardGet(url);
		await handleResponse(response, 'Run Archive', 'archive', options);
	}
}
